var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrencyEuro = function SvgCurrencyEuro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16M8.736 6.979C9.208 6.193 9.696 6 10 6s.792.193 1.264.979a1 1 0 0 0 1.715-1.029C12.279 4.784 11.232 4 10 4s-2.279.784-2.979 1.95c-.285.475-.507 1-.67 1.55H6a1 1 0 0 0 0 2h.013a9 9 0 0 0 0 1H6a1 1 0 1 0 0 2h.351c.163.55.385 1.075.67 1.55C7.721 15.216 8.768 16 10 16s2.279-.784 2.979-1.95a1 1 0 1 0-1.715-1.029c-.472.786-.96.979-1.264.979s-.792-.193-1.264-.979a4 4 0 0 1-.264-.521H10a1 1 0 1 0 0-2H8.017a7 7 0 0 1 0-1H10a1 1 0 1 0 0-2H8.472q.12-.279.264-.521",
    clipRule: "evenodd"
  })));
};
export default SvgCurrencyEuro;